import { UserData } from 'fetch'
import { createContext } from 'react'

interface contextProps {
  user: UserData | undefined | null
  themeModalStatus: string
  dispatch: any
  updateUnread: number
  from?: string
}
export const UserContext = createContext<contextProps>(
  {
    user: undefined, 
    themeModalStatus: 'hide', 
    dispatch: () => null,
    updateUnread: 0
  }
)
